<template>
  <div class="cooperation-add-wrapper global-card">
    <a-back-top :target="targetFn">
      <div class="ant-back-top-inner">
        <img
          src="./../../../../assets/f2.png"
          class="ant-back-top-img"
          alt=""
        />
        回顶部
      </div>
    </a-back-top>
    <bread-crumb />
    <a-card
      :bordered="false"
      style="width: 100%; border-radius: 10px; margin-bottom: 20px"
      :bodyStyle="{ paddingTop: '0 !important' }"
    >
      <a-select
        placeholder="请选择推广人"
        v-model="promoter_name"
        style="
          width: 225px;
          margin: 19px 0 19px 23px;
          float: right;
          border-radius: 15px;
        "
        :showSearch="true"
        @change="(value, option) => onChangePromoter(value, option)"
      >
        <a-select-option
          v-for="item in promoterData"
          :key="item.drugPromoter.id"
          :value="item.drugPromoter.user_realname"
        >
          {{ item.drugPromoter.user_realname }}
        </a-select-option>
      </a-select>

      <br style="clear: both" />
      <!-- 进度显示 -->
      <div class="col-box">
        <a-row type="flex" justify="center" align="middle">
          <a-col :span="2"><p class="col-header">总计：</p></a-col>
          <a-col :span="2"
            ><p class="col-body">{{ reportDatasTotal.assigned_num }}</p></a-col
          >
          <a-col :span="2"><p class="col-header">提交：</p></a-col>
          <a-col :span="2"
            ><p class="col-body">{{ reportDatasTotal.create_num }}</p></a-col
          >
          <a-col :span="2"><p class="col-header">通过：</p></a-col>
          <a-col :span="2"
            ><p class="col-body">{{ reportDatasTotal.pass_num }}</p></a-col
          >
          <a-col :span="2"><p class="col-header">驳回：</p></a-col>
          <a-col :span="2"
            ><p class="col-body">{{ reportDatasTotal.refuse_num }}</p></a-col
          >
          <a-col :span="2"><p class="col-header">剩余：</p></a-col>
          <a-col :span="2"
            ><p class="col-body">
              {{ reportDatasTotal.assigned_num - reportDatasTotal.create_num }}
            </p></a-col
          >
          <a-col :span="2"><p class="col-header">完成率/通过率：</p></a-col>
          <a-col :span="2"
            ><p class="col-body">
              {{
                reportDatasTotal.assigned_num &&
                (
                  (reportDatasTotal.create_num /
                    reportDatasTotal.assigned_num) *
                  100
                ).toFixed(1)
              }}%/{{
                reportDatasTotal.assigned_num &&
                (
                  (reportDatasTotal.pass_num / reportDatasTotal.assigned_num) *
                  100
                ).toFixed(1)
              }}%
            </p></a-col
          >
        </a-row>
      </div>

      <form-card ref="formcard2" :form-data="formData2">
        <template #name>
          <a-table
            :pagination="false"
            :columns="columns2"
            :data-source="reportDatasList"
            :loading="loading"
            :row-key="(record) => record.id"
            :row-selection="{
              selectedRowKeys,
              onChange: onchangeCheck,
              getCheckboxProps: getCheckboxProps,
            }"
          >
            <!-- 使用资料 -->
            <template slot="task_docment_name" slot-scope="text, record">
              <a-tooltip
                placement="bottomLeft"
                :title="
                  record.map_info.name
                    ? '【' +
                      record.map_info.obj_type_text +
                      '】' +
                      record.map_info.name
                    : ''
                "
                color="#13c2c2"
                value="false"
                disabled="true"
              >
                <span
                  class="ellipsis"
                  style="width: 300px"
                  v-if="record.map_info.name"
                >
                  【{{ record.map_info.obj_type_text }}】{{
                    record.map_info.name
                  }}
                </span>
                <span v-else>-</span>
              </a-tooltip>
            </template>

            <!-- 签到地址 -->
            <template slot="sign_address" slot-scope="text, record">
              <a-tooltip
                placement="bottomLeft"
                :title="record.workReportDetail.report_value.business_name"
                color="#13c2c2"
              >
                <span class="ellipsis" style="width: 410px"
                  >客户：{{
                    record.workReportDetail.report_value.business_name || "-"
                  }}</span
                >
              </a-tooltip>
              <a-tooltip
                placement="bottomLeft"
                :title="record.workReportDetail.report_value.sign_address"
                color="#13c2c2"
              >
                <span class="ellipsis" style="width: 410px"
                  >地址：{{
                    record.workReportDetail.report_value.sign_address || "-"
                  }}</span
                >
              </a-tooltip>
            </template>

            <!-- 状态以及不通过原因 -->
            <template slot="status" slot-scope="text, record">
              <a-tooltip
                placement="bottomLeft"
                :title="record.verify_desc"
                color="#13c2c2"
              >
                {{ text | statusName }}
              </a-tooltip>
            </template>

            <!-- 操作 -->
            <template slot="operation" slot-scope="text, record">
              <span
                v-for="(operationName, index) in Utils.getReportOperation(
                  $store.state.user.role,
                  record.status
                )"
                :key="operationName"
              >
                <a
                  v-if="operationName !== '无效'"
                  href="javascript:;"
                  @click="() => action(record, operationName)"
                  >{{ operationName }}</a
                >
                <popconfirm-button
                  v-else
                  text="无效"
                  alert-title="确定删除？"
                  @onDelete="() => onReportDelete(record)"
                />
                <a-divider
                  v-if="
                    index !==
                    Utils.getReportOperation(
                      $store.state.user.role,
                      record.status
                    ).length -
                      1
                  "
                  type="vertical"
                />
              </span>
              <template
                v-if="
                  $store.state.user.role === 1 &&
                  (record.status === 0 || record.status === 3)
                "
              >
                <a-divider type="vertical" />
                <popconfirm-button
                  text="删除"
                  alert-title="确定删除？"
                  @onDelete="() => onReportDelete(record)"
                />
              </template>
            </template>
          </a-table>
        </template>
      </form-card>

      <table-button
        class="form-card-button"
        :btn-is-loading="btnIsLoading"
        :submit-is-show="submitIsShow"
        :hasSelected="hasSelected"
        @onSubmit="onListSubmit"
        @handlesubmit="handlesubmit"
        @handlereject="handlereject"
        @onCancel="onListCancel"
      />
    </a-card>

    <div class="org-mseeage-wrapper">
      <a-card
        :bordered="false"
        style="width: 100%; border-radius: 10px; position: relative"
      >
        <div class="title">服务计划</div>
        <div class="orginfo-wrapper">
          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">服务协议</p>
              <p class="flex-item-right" style="text-align: right">
                {{ reportRelations.title }}
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">服务项目</p>
              <p class="flex-item-right" style="text-align: right">
                {{ reportRelations.name }}
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">服务商</p>
              <p class="flex-item-right" style="text-align: right">
                {{ reportRelations.qichacha_name }}
              </p>
            </div>
            <div
              class="flex-item-content"
              v-if="reportRelations.service_id == 19"
            >
              <p class="flex-item-left" style="text-align: left">调研类型</p>
              <!-- 线上调研 -->
              <div style="text-align: end">
                <div v-if="reportRelations.offline_share.offline">
                  <el-checkbox
                    v-model="reportRelations.offline_share.offline"
                    disabled
                    >线下</el-checkbox
                  >
                </div>
                <div v-if="reportRelations.offline_share.share">
                  <el-checkbox
                    v-model="reportRelations.offline_share.share"
                    disabled
                    >分享</el-checkbox
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">目标产品</p>
              <p class="flex-item-right" style="text-align: right"></p>
              <div class="flex-item-right" style="text-align: right">
                <div
                  v-for="(item, index) in reportRelations.products"
                  :key="index"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">关联资料</p>
              <div class="flex-item-right" style="text-align: right">
                <div
                  v-for="(item, index) in reportRelations.datas"
                  :key="index"
                >
                  （{{ index + 1 }}）【{{ item.link_datas.obj_type_text }}】{{
                    item.link_datas.name
                  }}
                </div>
                <span
                  v-if="
                    reportRelations.hasOwnProperty('datas') &&
                    !reportRelations.datas.length
                  "
                  >无</span
                >
              </div>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">工作量</p>
              <p class="flex-item-right" style="text-align: right">
                {{ reportRelations.plan_num }}次
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">清单金额</p>
              <p class="flex-item-right" style="text-align: right">
                {{ reportRelations.total_money }}元
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">服务城市</p>
              <p class="flex-item-right" style="text-align: right">
                {{ reportRelations.path_txt }}
              </p>
            </div>
          </div>
          <div class="flex-item-wrapper">
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">开始时间</p>
              <p class="flex-item-right" style="text-align: right">
                {{ reportRelations.service_start_time }}
              </p>
            </div>
            <div class="flex-item-content">
              <p class="flex-item-left" style="text-align: left">结束时间</p>
              <p class="flex-item-right" style="text-align: right">
                {{ reportRelations.service_end_time }}
              </p>
            </div>
          </div>
        </div>
        <div class="title">产品说明</div>
        <div class="flex-item-wrapper business-scope-wrapper">
          <div class="business-scope-content">
            <div
              v-for="item in reportRelations.relationProducts"
              :key="item.id"
              class="product-item"
            >
              <div
                v-if="
                  item.id == productFilterId &&
                  reportRelations.service_id == item.service_id &&
                  reportRelations.need_relation_product
                "
              >
                <div>
                  <span>产品名称：</span>
                  {{ item.title }}
                </div>
                <div>
                  <span>产品规格：</span>
                  {{ item.spec || "无" }}
                </div>
                <!-- <div>
                <span>产品剂型：</span>
                {{ item.product_form }}
              </div> -->
                <!-- <div>
                <span>国药准字号：</span>
                {{ item.nmpn }}
              </div> -->
                <div>
                  <span>产品描述：</span>
                  {{ item.describe || "无" }}
                </div>
              </div>
            </div>

            <!-- 产品规格 -->
            <div
              v-for="(item, index) in reportRelations.relation_product_group"
              :key="index"
              class="product-item"
            >
              <div v-if="reportRelations.need_show_product">
                <div>
                  <span>产品名称：</span>
                  {{ item.title }}
                </div>
                <div>
                  <span>产品规格：</span>
                  {{ item.spec || "无" }}
                </div>
                <div>
                  <span>产品描述：</span>
                  {{ item.describe || "无" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </a-card>
    </div>

    <details-modal
      ref="reportDetail"
      title="查看报告"
      :data="reportDetailData"
      :defaultServiceConfigs="defaultServiceConfigs"
      :visible="isVisibleDetail"
      @onCancel="closeReportDetailModal"
    />
      <compare-modal
      title="相似图片查重"
      :data="reportDetailForCompare"
      :visible="pictureCompareVisible"
      :companyId="companyId"
      @onCancel="closePictureCompareModal"
    />
    <confirm-modal
      :btn-is-loading="btnIsLoadingConfirm"
      :visible="isVisibleConfirm"
      @onSubmit="onReportConfirmSubmit"
      @onCancel="closeReportConfirmModal"
    />
    <reject-modal
      ref="reportReject"
      :btn-is-loading="btnIsLoadingReject"
      title="温馨提示"
      :data="reportDetailData"
      :visible="isVisibleReject"
      @onSubmit="onReportRejectSubmit"
      @onCancel="closeReportReject"
    />
  </div>
</template>
<script>
import { columns1, formData2, columns2 } from "./../data";
import Utils from "./../utils/getStatus.js";
import TableButton from "./../components/TableButton";
import { getColumns, getReportTableData } from "./../utils/getColumns";
import { getAddButton } from "./../utils/getAddButton";
import { reportSubmit } from "./../utils/getSubmit";
import detailsModal from "./../modal/detailsModal";
import compareModal from "./../modal/compareModal";
import editModal from "./../modal/editModal";
import confirmModal from "./../modal/confirmModal";
import rejectModal from "./../modal/rejectModal";
export default {
  components: {
    TableButton,
    detailsModal,
    confirmModal,
    rejectModal,
    compareModal
  },
  filters: {
    statusName(val) {
      const status = {
        "-1": "已废弃",
        0: "待提交",
        1: "待审核",
        2: "通过",
        3: "驳回",
      };
      return status[val];
    },
  },
  data() {
    return {
      hasSelected: false,
      selectedRowKeys: [],
      btnIsLoading: false,
      btnIsLoadingConfirm: false,
      btnIsLoadingEdit: false,
      btnIsLoadingReject: false,
      Utils,
      columns1,
      columns2,
      reportTableData: [],
      reportTableDataTemp: [],
      agreement_service: [],
      formData2,
      loading: false,
      agreementData: [],
      data1: {},
      name: "",
      agreement_id: "",
      orgInfo: {},
      columns: [],
      isShowAddbtn: true,
      isVisibleAdd: false,
      formData: [],
      formData1: [],
      isVisibleDetail: false,
      pictureCompareVisible: false,
      reportDetailForCompare: [],
      reportDetailData: [],
      isVisibleConfirm: false,
      isVisibleReject: false,
      reportId: "",
      tabData: [],
      submitIsShow: true,
      tabIndex: 1,
      promoterData: [],
      promoter_id: "",
      promoter_name: "",
      reportDatasList: [],
      reportRelations: [],
      reportDatasTotal: {
        assigned_num: 0,
        create_num: 0,
        pass_num: 0,
        refuse_num: 0,
      },
      // 单个审核通过
      singleConfirm: false,
      // 竞品信息的默认选项配置
      defaultServiceConfigs: [],
      productFilterId: 0,
      companyId: 0,
    };
  },
  created() {
    // 获取清单数据
    // this.getData({ id: this.$route.query.id }, this.tabIndex);
    // 获取用户信息

    this.companyId = Number(this.$route.query.company_id);
    this.getUser();
    this.$role = this.$store.state.user.role;
    let status = Number(this.$route.query.status);
    if (this.$role === 0) {
      this.submitIsShow = false;
    } else {
      if (status === 2) {
        this.submitIsShow = true;
      } else {
        this.submitIsShow = false;
      }
    }

    this.getPromoterList();
    this.getReportRelations();
  },
  methods: {
    targetFn() {
      return document.querySelector("#layoutContent");
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.status === 2 || record.status === 3,
        },
      };
    },
    async handlesubmit() {
      this.isVisibleConfirm = true;
    },
    async handlereject() {
      this.isVisibleReject = true;
      let result = await this.$http.post("/WorkReport/getFormInfo", {
        id: this.selectedRowKeys.join(","),
        work_list_id: this.$route.query.id,
      });
      this.reportDetailData = result.data.data.formItemGroup;
      this.$refs.reportReject.form.resetFields();
    },
    // 获取推广人列表
    async getPromoterList() {
      let params = { id: this.$route.query.id };
      let result = await this.$http.post("/WorkList/promoterList", params);

      this.promoterData = result.data.data;
      this.promoter_id = this.promoterData[0].drugPromoter.id;
      this.promoter_name = this.promoterData[0].drugPromoter.user_realname;

      this.getReportList({
        id: this.$route.query.id,
        promoter_id: this.promoter_id,
      });
    },
    onchangeCheck(selectedRowKeys, selectedRows) {
      // 设置单个审核为false
      this.singleConfirm = false;
      if (selectedRowKeys.length > 0) {
        this.hasSelected = true;
      } else {
        this.hasSelected = false;
      }
      this.selectedRowKeys = selectedRowKeys;
    },
    // 点击tab
    handleTab(index) {
      this.tabIndex = index;
      this.reportTableData = this.reportTableDataTemp[this.tabIndex - 1];
    },
    // 获取表单配置
    async getFormConfig(id) {
      let result = await this.$http.post("/WorkReport/getFormInfo", id);
      if (result.data.status === 1) {
        let data = result.data.data.formItemGroup;
        this.formData1 = data;
        this.formData = data.filter((item) => ![2, 3, 4].includes(item.type));
        console.log("TCL: getFormConfig -> this.formData", this.formData);
      }
    },
    // 获取清单数据
    async getData(params, tabKey) {
      this.loading = true;
      let result = await this.$http.post("/WorkList/show", params);
      if (result.data.status === 1) {
        this.loading = false;
        this.tabData = result.data.data.workReportList;
        this.columns = getColumns(result);

        this.reportTableDataTemp = getReportTableData(result);
        this.reportTableData = this.reportTableDataTemp[tabKey - 1];
        this.isShowAddbtn = getAddButton(result, this.$role);
        let data = result.data.data;
        this.orgInfo = {
          title: data.work_plan.agreement_info.title,
          name: data.service_info.name,
          qichacha_name:
            data.work_plan.agreement_info.service_provider_info.companyInfo
              .qichacha_name,
          plan_num: data.plan_num,
          total_money: data.total_money,
          path_txt: data.work_plan.agreement_info.path_txt,
          service_start_time: this.$Format(data.work_plan.plan_start_time),
          service_end_time: this.$Format(data.work_plan.plan_end_time),
          products: data.work_plan.agreement_info.agreement_product,
          datas: data.work_plan.product_link_datas,
        };
        // console.log("this.orgInfo", this.orgInfo);
      }
    },
    // 获取用户信息
    async getUser() {
      let result = await this.$http.post("/manager/getCompanyManagerInfo");
      if (result.data.status === 1) {
        this.name = result.data.data.company.team_name;
      }
    },
    // 清单提交
    async onListSubmit() {
      // 企业
      if (this.$role === 0) {
        console.log("this.$role", this.$role);
        this.btnIsLoading = true;
        let result = await this.$http.post("/WorkList/verify", {
          id: this.$route.query.id,
        });
        this.btnIsLoading = false;
        if (result.data.status === 1) {
          this.$message.success("操作成功！");
          this.$router.back();
        }
      }
      // 服务商
      if (this.$role === 1) {
        this.btnIsLoading = true;
        let result = await this.$http.post("/WorkList/submit", {
          id: this.$route.query.id,
        });
        this.btnIsLoading = false;
        if (result.data.status === 1) {
          this.$message.success("操作成功！");
          this.$router.back();
        }
      }
    },
    // 取消提交清单
    onListCancel() {
      this.$router.back();
    },
    // 报告操作
    async action(record, operationName) {
      const { status, sourceData, id } = record;
      this.reportId = id;
      // 查看
      if (operationName === "查看") {
        this.isVisibleDetail = true;
        let result = await this.$http.post("/WorkReport/getReportDetail", {
          id: this.reportId,
          work_list_id: this.$route.query.id,
        });
        this.reportDetailData = result.data.data;

        let serviceFlag = this.reportDetailData.workList.service_info.flag;
        if (serviceFlag === "competitive" || serviceFlag === "terminalcall") {
          let serviceConfigs = await this.$http.post(
            "/WorkReport/defaultServiceConfigs",
            { type: serviceFlag }
          );
          this.defaultServiceConfigs = serviceConfigs.data.data;
        }
      }
      // 通过
      if (operationName === "通过") {
        this.isVisibleConfirm = true;
        this.singleConfirm = true;
        console.log("sourceData", sourceData);
      }
      // 驳回
      if (operationName === "驳回") {
        this.isVisibleReject = true;
        // let result = await this.$http.post("/WorkReport/getFormInfo", {
        //   id: this.reportId,
        //   work_list_id: this.$route.query.id,
        // });
        // this.reportDetailData = result.data.data.formItemGroup;
        // this.$refs.reportReject.form.resetFields();
      }
      // 编辑
      if (operationName === "编辑") {
        this.isVisibleAdd = true;
        console.log("isVisibleAdd", isVisibleAdd);
        let result = await this.$http.post("/WorkReport/getFormInfo", {
          id: this.reportId,
          work_list_id: this.$route.query.id,
        });
        this.formData = result.data.data.formItemGroup;
        console.log("TCL: action ->  this.formData ", this.formData);
      }
      if (operationName === "去重") {
        this.pictureCompareVisible = true;
        let result = await this.$http.post("/WorkReport/getReportDetail", {
          id: this.reportId,
          work_list_id: this.$route.query.id,
        });
        this.reportDetailForCompare = result.data.data;
      }
    },
    // 报告详情-关闭
    closeReportDetailModal() {
      this.isVisibleDetail = false;
    },
    // 报告详情-关闭
    closePictureCompareModal() {
      this.pictureCompareVisible = false;
    },
    // 报告通过-提交
    async onReportConfirmSubmit() {
      this.btnIsLoadingConfirm = true;
      let confirmIds = "";
      // 单个审核
      if (this.singleConfirm) {
        confirmIds = this.reportId;
      } else if (this.hasSelected) {
        confirmIds = this.selectedRowKeys.join(",");
      }

      let result = await this.$http.post("/WorkReport/verify", {
        id: confirmIds,
        verify_result: 1,
        verify_desc: "",
      });
      this.btnIsLoadingConfirm = false;
      if (result.data.status === 1) {
        this.isVisibleConfirm = false;
        this.$message.success("操作成功！");
        // 获取清单数据
        this.getReportListByPromoter();
        // 全部状态重置
        this.closeReportConfirmModal();
      }
    },
    // 报告驳回-关闭
    closeReportReject() {
      this.isVisibleReject = false;
    },
    // 报告驳回-提交
    async onReportRejectSubmit() {
      this.$refs.reportReject.form.validateFields(async (err, values) => {
        if (!err) {
          this.btnIsLoadingReject = true;
          let result = await this.$http.post("/WorkReport/verify", {
            id: this.hasSelected
              ? this.selectedRowKeys.join(",")
              : this.reportId,
            verify_result: 0,
            verify_desc: values.verify_desc,
          });
          this.btnIsLoadingReject = false;
          if (result.data.status === 1) {
            this.isVisibleReject = false;
            this.$message.success("操作成功！");
            // 获取清单数据
            this.getReportListByPromoter();
          }
        }
      });
    },
    // 报告通过-取消
    closeReportConfirmModal() {
      this.isVisibleConfirm = false;
      this.selectedRowKeys = [];
      this.singleConfirm = false;
      this.reportId = "";
      this.hasSelected = false;
    },
    // 删除报告
    async onReportDelete({ id }) {
      let result = await this.$http.post("/WorkReport/delete", { id });
      if (result.data.status === 1) {
        this.getReportListByPromoter();
      }
    },
    // 报告提交
    async onReportSubmit() {
      this.$refs.reportForm.form.validateFields(async (err, values) => {
        if (!err) {
          console.log("TCL: onSubmit -> values", values);
          const form_items = Object.keys(values).map((id) => ({
            id,
            value: reportSubmit(values[id]),
          }));
          const formData = {
            id: this.reportId ? this.reportId : undefined,
            work_list_id: this.$route.query.id,
            desc: undefined,
            form_items,
          };
          this.btnIsLoadingEdit = true;
          let result = await this.$http.post("/WorkReport/update", formData);
          this.btnIsLoadingEdit = false;
          if (result.data.status === 1) {
            this.isVisibleAdd = false;
            this.$message.success("操作成功！");
            this.getData({ id: this.$route.query.id }, this.tabIndex);
          }
        }
      });
    },
    // 提交
    async onSubmit() {
      let form1 = false;
      let formData;
      this.$refs.formcard1.form.validateFields((err, values) => {
        if (!err) {
          formData = values;
          console.log("TCL: onSubmit -> data", formData);
          form1 = true;
        }
      });

      const list = this.agreement_service.filter((item, index) => {
        return (
          this.selectedRowKeys.includes(index + 1) &&
          item.per_cost &&
          item.plan_num
        );
      });
      if (list.length === 0) {
        return;
      }
      let data = {
        id: this.$route.query.id ? this.$route.query.id : undefined,
        agreement_id: this.agreement_id,
        title: formData.title,
        plan_start_time: this.$moment(formData.plan_time[0]).unix(),
        plan_end_time: this.$moment(formData.plan_time[1]).unix(),
        materials_cost: parseInt(formData.materials_cost),
        link_services: list,
      };
      if (form1) {
        let result = await this.$http.post("/WorkPlan/update", data);
        if (result.data.status === 1) {
          this.$message.success("操作成功！");
          this.$router.back();
        }
      }
    },
    // 取消
    onCancel() {},
    // table check
    onSelectChange(selectedRowKeys) {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    // 选择推广人
    onChangePromoter(value, option) {
      this.promoter_name = value;
      this.promoter_id = option.data.key;
      this.getReportListByPromoter();
    },
    // 根据选择的推广人获取其报告
    getReportListByPromoter() {
      let params = { id: this.$route.query.id, promoter_id: this.promoter_id };
      this.getReportList(params);
    },
    // 获取推广人的报告
    async getReportList(params) {
      this.loading = true;
      let result = await this.$http.post("/WorkList/reportList", params);

      if (result.data.status == 1) {
        this.reportDatasList = result.data.data.detail;
        this.reportDatasTotal = result.data.data.report_datas;
        this.tabData = this.reportDatasList;
      } else {
        this.$message.warning(result.data.msg);
      }
      this.loading = false;
    },
    // 获取报告相关信息
    async getReportRelations() {
      let params = { id: this.$route.query.id };
      let result = await this.$http.post("/WorkList/relations", params);

      let service_id = result.data.data.service_id;
      let currService = result.data.data.work_plan.service_detail.filter(
        function (item) {
          return item.id == service_id;
        }
      );

      this.productFilterId =
        currService[0].relation_for_product == null
          ? 0
          : currService[0].relation_for_product.id;
      console.log("currService--->", currService);

      this.reportRelations = {
        title: result.data.data.work_plan.agreement_info.title,
        name: result.data.data.service_info.name,
        qichacha_name:
          result.data.data.work_plan.agreement_info.service_provider_info
            .companyInfo.qichacha_name,
        plan_num: result.data.data.plan_num,
        total_money: result.data.data.total_money,
        path_txt: result.data.data.work_plan.agreement_info.path_txt,
        service_start_time: this.$Format(
          result.data.data.work_plan.plan_start_time
        ),
        service_end_time: this.$Format(
          result.data.data.work_plan.plan_end_time
        ),
        offline_share: currService[0].configs,
        service_id: currService[0].id,
        products: [
          {
            title:
              currService[0].relation_for_product == null
                ? "无"
                : currService[0].relation_for_product.title,
          },
        ],
        relationProducts:
          result.data.data.work_plan.agreement_info.agreement_product,
        relation_product_group: currService[0].relation_product_group,
        datas: currService[0].relation_for_datas,
        need_show_product: result.data.data.service_info.need_show_product,
        need_relation_product:
          result.data.data.service_info.need_relation_product,
        // products: result.data.data.work_plan.agreement_info.agreement_product,
        // datas: result.data.data.work_plan.product_link_datas,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.cooperation-add-wrapper {
  margin-bottom: 40px;
  .title {
    font-size: 16px;
    padding-left: 20px;
    margin-left: -32px;
    border-left: 1px solid #46d3dd;
  }
  .business-scope-wrapper {
    .business-scope-head {
      margin-top: -35px;
      font-size: 16px;
    }
    .business-scope-content {
      background: rgba(249, 249, 252, 1);
      border-radius: 10px;
      padding: 20px;
      margin: 20px 10px;
      min-height: 100px;
      .product-item {
        margin-bottom: 20px;
      }
    }
  }
  .form-card-wrapper {
    margin-top: 20px;
    .ant-card-body {
      display: block;
      padding-bottom: 0;
    }
  }
  .form-card-upload {
    .upload-title {
      position: relative;
      top: -9px;
      right: -191px;
      color: #c3c7d5;
      font-size: 12px;
    }
    .ant-upload-text {
      color: #d6daea;
      margin-top: 50px;
    }
  }
  .form-card-button {
    background: #f9f9fc;
    margin: 0 -32px -24px -32px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    transform: translateY(10px);
  }
  .table-input {
    padding-top: 28px;
    .error-note {
      margin-top: 6px;
      color: #f5222d;
      height: 20px;
    }
  }
  .form-card-title {
    border-left: 1px solid #46d3dd;
    margin-left: -32px;
    padding-left: 20px;
    font-size: 16px;
    color: #565c66;
    .error-note-title {
      color: #f5222d;
      font-size: 12px;
      margin-left: 10px;
    }
  }
  .input-number {
    width: 200px;
  }
  .tab-title {
    font-size: 18px;
    margin-right: 10px;
  }
  .tab-number {
    font-size: 14px;
    margin-right: 10px;
  }
}
.col-box {
  background-color: rgb(230, 247, 255);
  border: 1px solid rgb(145, 213, 255);
  border-radius: 3px;
}
.col-header {
  height: 35px;
  line-height: 35px;
  margin: 0;
  text-align: right;
  font-weight: 500;
  padding-right: 5px;
}
.col-body {
  height: 35px;
  line-height: 35px;
  margin: 0;
  text-align: left;
}
.ant-back-top {
  right: 10px;
  height: 60px;
  width: 60px;
  bottom: 150px;
  text-align: center;
}
.ant-back-top-img {
  margin: 0 auto 5px;
  display: block;
  width: 20px;
}
.ant-back-top-inner {
  height: 60px;
  width: 54px;
  border-radius: 4px;
  background-color: #1088e9;
  color: #fff;
  text-align: center;
  font-size: 12px;
  padding-top: 10px;
}
</style>
